module.exports = __webpack_public_path__ + "img/rake.be5030ca.webp";